
function globalGetResultPage(module) {
    
    var resultPage = '/ResultView/';
    
    //if (HAS_ANY_LEAD_MANAGER === 'true') {

    //    if ($.inArray(module, MODULES_WITH_LEAD_MANAGER) >= 0) {
    //        resultPage = '/ResultView/';
    //    }

    //    //if ((module && module.toLowerCase().indexOf('usbusiness') >= 0) ||
    //    //    (module && module.toLowerCase().indexOf('usconsumer') >= 0)) {
    //    //    resultPage = '/ResultView/';
    //    //}
    //}

    return resultPage;
}

$(function () {

	// Putting a #debug or #diagnostics in the url will open the diagnostics modal
	function hashChangeOpenDiagnostics() {
		var pieces = window.location.toString().split('#');

		if (pieces[1] == 'debug' || pieces[1] == 'diagnostics') {
			openDiagnosticsModal();
		}
	}

	$(window).bind('hashchange', hashChangeOpenDiagnostics);

	// If one of the key hashes are already in the url then open on load
	hashChangeOpenDiagnostics();

	function openDiagnosticsModal() {
		// If the modal is already open
		if ($('#diagnostics-list').length) {
			return false;
		}

		Origin.modal({
			url: '/Static/Diagnostics/full?p=' + document.location,
			draggable: false,
			title: 'Diagnostics',
			height: $(window).height() * 0.6,
			width: '80%',
			open: function () {
			    if (typeof (enableScraping) != 'undefined' && $.isFunction(enableScraping)) {
			        enableScraping();
			    }
				if (!$('body').hasClass('ie6')) {
					$('.ui-dialog').css('position', 'fixed');
				}

				$('#diagnostics-list h3').click(function () {
					$(this).toggleClass('open').next().slideToggle(150);
					return false;
				}).next().hide();

				$('#diagnostics-show-toggle-button').click(function () {
					if ($(this).text() == 'Expand All') {
						$(this).text('Collaspe All');
						$('#diagnostics-list h3').addClass('open').next().slideDown(150);
					}
					else {
						$(this).text('Expand All');
						$('#diagnostics-list h3').removeClass('open').next().slideUp(150);
					}
				});
            },
            close: function () {
                if (typeof (disableScraping) != 'undefined' && $.isFunction(disableScraping)) {
                    disableScraping();
                }
            }
		});
	}

	$(document).keyup(function (event) {
		var code = event.which,
				type = event.type,
				shift = event.shiftKey,
				ctrl = event.ctrlKey,
				alt = event.altKey || event.originalEvent.altKey;

		//log("code: " + code + ", " + "type: " + type + ", " + "shift: " + shift + ", " + "ctrl: " + ctrl + ", " + "alt: " + alt);

		// 107 = Numpad Plus (+)
		// 59/186 = Semi-colon (;)
		if (alt && ctrl && (code == 107 || code == 59 || code == 186)) {
			openDiagnosticsModal();
		}
	});
});

/**** String functions *****/
String.prototype.isNullOrEmpty = function () {
	if (this == null || $.trim(this).length == 0)
		return true;
	else
		return false;
};
String.prototype.replaceAll = function (pcFrom, pcTo) {
	var i = this.indexOf(pcFrom);
	var c = this + '';
	while (i > -1) {
		c = c.replace(pcFrom, pcTo);
		i = c.indexOf(pcFrom);
	}
	return c;
};
String.prototype.isEmpty = function () {
	return this.replaceAll("\t", "").replaceAll("\n", "").replaceAll("\r", "").replaceAll(" ", "").length == 0;
};
String.prototype.splitOn = function (arrayOfSplits) {
	var mySplitChar = '§';
	var c = this;
	for (var i = 0; i < arrayOfSplits.length; i++) {
		c = c.replaceAll(arrayOfSplits[i], mySplitChar);
	}
	return c.split(mySplitChar);
};
/*****************/

var Origin = {};

Origin.changeHeaderPageTitle = function (title) {
	if (typeof sgHeaderChangeTitle === 'function') {
		sgHeaderChangeTitle(title);
	}
};

Origin.FormatNumber = function (number) {
	number += "";
	var parts = number.split('.');
	var integer = parts[0];
	var dec = parts.length > 1 ? '.' + parts[1] : '';
	var regex = /(\d+)(\d{3})/;

	while (regex.test(integer))
		integer = integer.replace(regex, '$1' + ',' + '$2');

	return integer + dec;
};

Origin.ConvertPascalToCamel = function (string) {
	return string.charAt(0).toLowerCase() + string.substring(1);
};
Origin.ConvertCamelToPascal = function (string) {
	return string.charAt(0).toUpperCase() + string.substring(1);
};
Origin.ConvertCamelToUnderscore = function (string) {
	return string.replace(/([a-z])([A-Z])/g, '$1_$2')
					.replace(/([a-z])([0-9])/gi, '$1_$2')
					.replace(/([0-9])([a-z])/g, '$1_$2')
					.toLowerCase();
};
Origin.ConvertDashedToCamel = function (string) {
	var str = '';
	var upper = false;
	for (var i = 0; i < string.length; i++) {
		var current = string.charAt(i);
		if (current == '-') {
			upper = true;
			continue;
		}
		str += (upper ? current.toUpperCase() : current);
		upper = false;
	}
	return str;
};
Origin.ConvertCamelToDashed = function (string) {
	return Origin.ConvertCamelToUnderscore(string).replace(/_/g, '-');
};

Origin.htmlEncode = function (str) {
	return str.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); ;
};
Origin.htmlDecode = function (str) {
	return str.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"');
};

Origin.formatString = function () {
	var str = arguments[0];
	for (var i = 1; i < arguments.length; i++) {
		// The tripple escapes are required for IE, oh beautiful IE!
		str = str.replace(new RegExp('\\\{' + (i - 1) + '\\\}', 'g'), arguments[i]);
	}
	return str;
};

Origin.ToShortThousandsFormat = function() {

    var str = "";

    if (arguments[0] == null || arguments[0] == undefined)
        return str;

    str = arguments[0].toString();
    var length = str.length;

    if (length < 4)
        return str;

    if (length == 4)
        return str.substr(0, 1) + "K+";

    if (length == 5)
        return str.substr(0, 2) + "K+";

    if (length == 6)
        return str.substr(0, 3) + "K+";

    if (length == 7)
        return str.substr(0, 1) + "M+";

    if (length == 8)
        return str.substr(0, 2) + "M+";

    if (length == 9)
        return str.substr(0, 3) + "M+";

    if (length == 10)
        return str.substr(0, 1) + "B+";

    if (length == 11)
        return str.substr(0, 2) + "B+";

    if (length == 12)
        return str.substr(0, 3) + "B+";

    return str;
};

//is null or undefined check
Origin.isNullOrUndefined = Origin.isNullOrUndefined || function(testObj) { return (typeof testObj === 'undefined' || testObj == null); };

/*
* This method instantiates a hidden DIV and Ajax's the url specified into the dive returning
* a refernce to the DOM node. It additionally executes a load callback method with the second
* argument being a boolean value of true (success) or false (failed)
*/
Origin.loadAjaxContent = function (options) {
	if (typeof arguments[0] == 'string') {
		options = {
			url: arguments[0],
			load: arguments[1]
		};
	}

	options = $.extend({
		id: Origin.guid(),
		url: null,
		data: {},
		load: null,
		type: 'post',
		parent: $('body')
	}, options);
	//var id = options.id || ;
	var div = $('<div></div>')
		.css('display', 'none')
		.attr('id', options.id)
		.appendTo(options.parent);

	$.ajax({
		global: false,
		dataType: 'html',
		url: options.url,
		data: options.data,
		type: options.type,
		success: function (data) {
			div.append(data);
			if ($.isFunction(options.load)) {
				options.load.call(div[0], [true]);
			}
		},
		error: function () {
			div.html('<h1 class="title">Error: Unable to load content</h1>Unable to load content');
			if ($.isFunction(options.load)) {
				options.load.call(div[0], [false]);
			}
		}
	});
	return div[0];
};

/*
[	{	label: 'Cancel',
type: 'primary' || 'secondary' || 'default'
click: function() {
// Click handler
},
icon: '',
iconPosition: ''
},
{
}
]
*/
Origin.button = function (options) {
	var opts = $.extend({
		icon: '',
		iconPosition: 'left',
		click: jQuery.noop
	}, options);
	var btn = $('<a href="#" class="originButton"><span><span></span></span></a>')
		.addClass('ui-priority-' + (options.type || 'default') + (options.cssClass ? ' ' + options.cssClass : ''))
		.attr('id', options.id || '')
		.find('> span > span')
			.append(options.label)
		.end()
		.bind('click', function (evt) {
			if ($(this).hasClass('originButtonDisabled')) {
				evt.stopPropagation();
				evt.preventDefault();
				evt.stopImmediatePropagation();
				return false;
			} else {
				evt.preventDefault();
			}
		})
		.bind('click', options.click)
		.If(options.icon != null && options.icon != '')
			.addClass('originButtonIcon' + (options.iconPosition == 'right' ? ' originIconRight' : ''))
			.find('> span > span')
				.append('<img src="/Themes/Default/Content/Images/transparent.gif" class="ui-icon ' + options.icon + '" />')
			.end()
		.end();
	return btn[0];
};

Origin.modal = function (options) {
	options = $.extend({
		url: null,
		data: null,
		content: null,
		removeOnClose: options.content ? false : true,
		disableClose: false,
		cssClass: '',
		width: null,
		height: null,
		title: null,
		open: null, // Callback function
		close: null, // Close callback function
		beforeclose: null, // beforeclose callback function
		draggable: true,
		help: null,
		buttons: null,
		showCount: false,
		size: null,
		type: 'post',
        showContentLoading: true
	}, options);

	if (options.size) {
		if (options.size == 'small') {
			options.width = 350;
			options.height = 150;
		} else if (options.size == 'medium') {
			options.width = 570;
			options.height = 400;
		} else {
			options.width = 700;
			options.height = 500;
		}
	} else {
		options.width = options.width || 700;
		options.height = options.height || 500;
	}

	if (options.url) {
	    var timeout = setTimeout(function () {
	        if (options.showContentLoading) {
	            Origin.showLoading();
	        }
		}, 1000);
		options.content = Origin.loadAjaxContent({
			url: options.url,
			data: options.data || {},
			type: options.type,
			load: function () {
				clearTimeout(timeout);
				if (options.showContentLoading) {
			        Origin.hideLoading();
			    }
			    $(options.content)
					.addClass('originModal')
					.each(initializeModal);
			}
		});
	} else {
		$(options.content).each(initializeModal);
	}

	function initializeModal() {
		var dialogButtons = (function () {
			if (options.buttons) {
				var temp = {};

				$.each(options.buttons, function (i, item) {
					if (typeof item == 'string') {
						var index = item.substring(0, 1).toUpperCase() + item.substring(1);
						temp[index] = function () { $(this).trigger('modalclose') };
					} else if (typeof item != 'undefined')
						temp[item.label] = item.click;
				});

				return temp;
			}
		})();


		var modalOptions = $.extend({
			autoShow: true,
			bgiframe: true,
			draggable: options.draggable,
			modal: true,
			resizable: false,
            disableSmoothForm: false,
			closeOnEscape: options.closeOnEscape === false ? false : true,
			width: options.width || 570,
			height: options.height || 450,
			title: options.title || $(options.content).find('h1.title:eq(0)').remove().html(),


			buttons: dialogButtons,

			open: function () {
				var dialog = $(this).closest('.ui-dialog').addClass(options.cssClass);
				//				$('.ui-dialog-titlebar', dialog).removeClass('ui-widget-header ui-corner-all');

				// Bind an event so any buttons can close the dialog by triggering a close event
				dialog
					.bind('modalclose', function () {
						$('> .ui-dialog-content', this).dialog('close');
					})
					.bind('modalloadcontent', function (evt, url, data) {
						Origin.loadAjaxContent({
							url: url,
							data: data || '',
							load: function () {
								// Update the title
								var title = $(this).find('h1.title:eq(0)').remove().html();
								dialog
											.originModalContent()
												.empty()
												.append($(this).children());
								$(this).remove();

								if (title != '') {
									dialog.find('.ui-dialog-title').html(title);
								}
							}
						});
					});

				if (options.disableClose === true) {
					$('.ui-dialog-titlebar-close', dialog).remove();
				}

				// Add our help icon
				if (options.help) {
					var $info = $('<a title="information/help" href="#" class="ui-dialog-titlebar-help ui-corner-all"><span class="ui-icon ui-icon-help">info</span></a>');
					$info.click(function (evt) {
						Origin.showHelp(options.help);
						evt.preventDefault();
						return false;
					});
					$('div.ui-dialog-titlebar', dialog).append($info);
				}

				if (options.tip && !options.help) {
					var tipEl = $('<a href="#"></a>');

					tipEl
						.addClass('ui-dialog-titlebar-help ui-corner-all')
						.append('<span class="ui-icon ui-icon-help"></span>');

					options.tip.text && tipEl.attr('title', options.tip.text);

					options.tip['class'] && tipEl.addClass(options.tip['class']);

					dialog.find('div.ui-dialog-titlebar').append(tipEl);
				}

				// Add our buttons
				if (options.buttons) {
				    $.each(options.buttons, function (i, item) {
				        if (typeof item != 'undefined') {
				            var button = $('button .ui-button-text:contains("' + item.label + '")').closest('button');
				            var priority;

				            //						if (item.icon) {
				            //							debugger;
				            //							var position = item.iconPosition || 'left';
				            //							var iconPriority;
				            //							if (position == 'left')
				            //								button.prepend('<span class="ui-button-icon-primary ' + item.icon + '"></span>');
				            //							else
				            //								button.append('<span class="ui-button-icon-secondary ' + item.icon + '"></span>');
				            //						}

				            if (typeof item == 'string') {
				                switch (item) {
				                case 'close':
				                case 'done':
				                case 'ok':
				                    priority = 'primary';
				                    break;
				                default:
				                    priority = 'default';
				                }
				            }

				            if (item.type)
				                priority = item.type;
				            else
				                priority = 'default';

				            if (item.cssClass)
				                button.addClass(item.cssClass);
				            if (item.id)
				                button.attr('id', item.id);
				            if (item.position)
				                button.addClass('button-' + item.position);
				            else
				                button.addClass('ui-priority-' + priority);
				        }
				    });
				}

				if (options.showCount === true) {
					var container = $('<div class="update-count-container"></div>');
					dialog.bind('modalresetcount', function () {
						$('div.modalCount', this).html('N/A');
					});

					$('<div>Update Count</div>')
						.bind('click', function () { $(this).originModalContent().trigger('refreshcount'); })
						.button({ icons: { secondary: 'ui-icon-refresh'} })
						.appendTo(container);
					$('<div class="modalCount">N/A</div>').appendTo(container);
					dialog.find('div.ui-dialog-titlebar').append(container);

					dialog.bind('modalupdatecount', function (evt, count) {
						$('div.modalCount', this).html(Origin.FormatNumber(count));
					});
					dialog.bind('modalcountloading', function () {
						$('div.modalCount', this).addInlineLoading();
					});
				}

				Origin.addCheckedAttributes();

				if (!options.disableSmoothForm) {
				    $('body').smoothForm();
				}

				$('.origin-button', dialog).originButton();
				$('.origin-buttonset', dialog).originButtonset();

				if ($.isFunction(options.open)) {
					options.open.call(this, [dialog[0]]);
				}
			},
			close: function () {
                console.log('close')
				if ($.isFunction(options.close)) {
					options.close.call(this);
				}

				$(this).dialog('destroy');

				// Remove all of our content
				if (options.removeOnClose) {
					$(this).remove();
				} else {
					$(this).hide();
				}
			},
			beforeclose: function () {
				if ($.isFunction(options.beforeclose)) {
					options.beforeclose.call(this);
				}
			}
		}, options.dialog || {});
		$(this)
			.show()
			.dialog(modalOptions);
	}
};

// Takes the content div as the selector
$.fn.originModalClose = function () {
	return this.each(function () {
		// Do a little searching to find the dialog element to close
		$(this).closest('.ui-dialog').find('div.ui-dialog-content').dialog('close');
	});
};
$.fn.originModalLoadContent = function (url, data) {
	return this.each(function () {
		$(this).closest('.ui-dialog').trigger('modalloadcontent', [url, data]);
	});
};
// Selects the current dialogs modal content
$.fn.originModalContent = function () {
	// Wrap this to return a new stack
	return $(this).closest('.ui-dialog').find('div.ui-dialog-content');
};

$.fn.originModalElement = function () {
	return $(this).closest('.ui-dialog');
};

// 
Origin.contentModal = function (title, content, size, callback) {
	var id = Origin.guid();

	var div = $('<div></div>')
		.css('display', 'none')
		.attr('id', id)
		.html(content)
		.appendTo('body');

	Origin.modal({
		title: title,
		content: '#' + id,
		removeOnClose: true,
		size: 'large',
		buttons: [{ label: 'Done',
			click: function () {
				$(this).originModalClose();
				if ($.isFunction(callback)) {
					callback();
				}
			},
			type: 'primary'
		}],
		dialog: { resizable: true }
	});
};

/*
* Alert modal, takes a title, content and a callback method to execute upon the user clicking ok.
*/
Origin.alert = function (title, content, callback, options) {
	var defaults = {
		size: null,
		height: null,
		width: null
	};
	var settings = $.extend({}, defaults, options);
	if (!settings.height && !settings.width)
		settings.size = settings.size || 'small';
	var id = Origin.guid();

	var div = $('<div></div>')
		.css('display', 'none')
		.attr('id', id)
		.html(content)
		.appendTo('body');

	Origin.modal({
		title: title,
		content: '#' + id,
		removeOnClose: true,
		disableClose: true,
		size: settings.size,
		height: settings.height,
		width: settings.width,
		buttons: [{
			label: 'Ok',
			click: function () {
				$(this).originModalClose();
				if ($.isFunction(callback)) {
					callback();
				}
			},
			type: 'primary',
			cssClass: 'default-action'
		}],
		dialog: { closeOnEscape: false }
	});
};
/*
* Confirmation modal
*/
Origin.confirm = function (title, content, callback, options) {
	var defaults = {
		size: null,
		height: null,
		width: null,
		yesButtonLabel: 'Ok',
		noButtonLabel: 'Cancel'
	};
	var settings = $.extend({}, defaults, options);
	if (!settings.height && !settings.width)
		settings.size = settings.size || 'small';
	var id = Origin.guid();

	var div = $('<div></div>')
		.css('display', 'none')
		.attr('id', id)
		.html(content)
		.appendTo('body');

	Origin.modal({
		title: title,
		content: '#' + id,
		removeOnClose: true,
		disableClose: true,
		size: settings.size,
		height: settings.height,
		width: settings.width,
		buttons: [{
		    label: settings.noButtonLabel,
			click: function () {
				$(this).originModalClose();
				if ($.isFunction(callback)) {
					callback(false);
				}
			}
		},
		{
			label: settings.yesButtonLabel,
			click: function () {
				$(this).originModalClose();
				if ($.isFunction(callback)) {
					callback(true);
				}
			},
			type: 'primary',
			cssClass: 'default-action'
		}],
		dialog: { closeOnEscape: false }
	});
};

Origin.confirmDialer = function(title, content, callback, labelResume, labelEnd, canEndCall, options) {
    var defaults = {
        size: null,
        height: null,
        width: null
    };
    var settings = $.extend({}, defaults, options);
    if (!settings.height && !settings.width)
        settings.size = settings.size || 'small';
    var id = Origin.guid();

    var div = $('<div></div>')
        .css('display', 'none')
        .attr('id', id)
        .html(content)
        .appendTo('body');

    if (Origin.isNullOrUndefined(labelResume) || labelResume.isNullOrEmpty()) {
        labelResume = 'Resume';
    }

    if (Origin.isNullOrUndefined(labelEnd) || labelEnd.isNullOrEmpty()) {
        labelEnd = 'End';
    }

    var dialogButtons;

    if (canEndCall) {
        dialogButtons = [{
                label: labelEnd,
                click: function() {
                    $(this).originModalClose();
                    if ($.isFunction(callback)) {
                        callback(true);
                    }

	                Origin.doAction('dialerCampaignEnded');
                }
            },
            {
                label: labelResume,
                click: function() {
                    $(this).originModalClose();
                    if ($.isFunction(callback)) {
                        callback(false);
                    }
                },
                type: 'primary',
                cssClass: 'default-action'
            }];
    } else {
        dialogButtons = [{
            label: labelResume,
            click: function() {
                $(this).originModalClose();
                if ($.isFunction(callback)) {
                    callback(false);
                }
            },
            type: 'primary',
            cssClass: 'default-action'
        }];
    }
    
    Origin.modal({
        title: title,
        content: '#' + id,
        removeOnClose: true,
        disableClose: true,
        size: settings.size,
        height: settings.height,
        width: settings.width,
        buttons: dialogButtons,
        //buttons: [{
        //        label: labelEnd,
        //        click: function() {
        //            $(this).originModalClose();
        //            if ($.isFunction(callback)) {
        //                callback(true);
        //            }
        //        }
        //    },
        //    {
        //        label: labelResume,
        //        click: function() {
        //            $(this).originModalClose();
        //            if ($.isFunction(callback)) {
        //                callback(false);
        //            }
        //        },
        //        type: 'primary',
        //        cssClass: 'default-action'
        //    }],
        dialog: { closeOnEscape: false }
    });
};

Origin.Selectable = function (name, container, json, selectedKeys) {
	var i;
	var keyFound;
	var input = $('<input name="' + name + '" type="hidden" value="" />');
	var option;
	var options = $('<div class="options"></div>');
	var selections = $('<div class="selections"></div>');
	var addInputValue = function (newValue) {
		var currentValue = input.val();
		if (currentValue.length != 0) {
			currentValue += ",";
		}
		currentValue += newValue;
		input.val(currentValue);
	}
	var removeInputValue = function (value) {
		if (value == "*") {
			input.val("");
		}
	}
	container.addClass("selectable");
	container.append(input);
	container.append(options);
	container.append(selections);
	for (i = 0; i < json.length; i++) {
		if (json[i].Label.length > 0) {
			option = $('<div class="option ' + json[i].Key + '">' + json[i].Label + '</div>');
			keyFound = false;
			$.each(
				selectedKeys,
				function () {
					if (this == json[i].Key) {
						keyFound = true;
					}
				}
			);
			if (keyFound) {
				selections.append(option);
				addInputValue(json[i].Key);
			}
			else {
				options.append(option);
			}
		}
	}
	options.selectable(
		{
			items: ".option",
			selected: function (event, ui) {
				selections.append($(ui.selected));
				addInputValue($(ui.selected).attr("class").split(" ")[1]);
			}
		}
	);
	selections.sortable(
		{
			items: ".option",
			stop: function (event, ui) {
				removeInputValue("*");
				selections.find(".option").each(
					function () {
						addInputValue($(this).attr("class").split(" ")[1]);
					}
				);
			}
		}
	);
};

/*
Origin.Tooltips = function(element) {
if (!element) {
element = $("#searchInterface");
}
element.find(".tooltip").tooltip(
{
extraClass: "tooltipWindowPadded",
delay: 50,
left: 20,
showURL: false,
top: 0,
track: true
}
);
element.find(".tooltipImg").each(
function() {
var preloadElement = $("<img />");
var src = $(this).attr("href") + "?type=mouseover";
preloadElement.attr("src", src);
$(this).click(
function(event) {
window.open($(this).attr("href"));
return false;
}
);
$(this).tooltip(
{
bodyHandler: function() {
return $('<img alt="" height="300" src="' + src + '" width="400" />');
},
delay: 50,
extraClass: "tooltipWindow",
showURL: false,
track: true
}
);
}
);
};
*/

/*
Origin.TrimCells = function(element, maximumGylphSize) {
if (!element) {
element = $("#searchInterface");
}
if (typeof maximumGylphSize == "undefined") {
maximumGylphSize = 7.5;
}
element.find(".row:not(.header) > .cell").each(
function() {
var cellWidth;
var maximumGylphs;
var text;
cellWidth = $(this).width();
text = $.trim($(this).text());
if (cellWidth < text.length * maximumGylphSize) {
maximumGylphs = Math.round(cellWidth / maximumGylphSize) - 3;
if (maximumGylphs < 1) {
maximumGylphs = 1;
}
if ($(this).find("a").length > 0) {
$(this).find("a").addClass("tooltip").attr("title", text).text($.trim(text.substring(0, maximumGylphs)) + "...");
}
else {
$(this).html('<a class="tooltip" title="' + text + '">' + $.trim(text.substring(0, maximumGylphs)) + "..." + '</a>');
}
}
}
);
Origin.Tooltips(element);
};
*/
/*
Origin.TypeAhead = function(element, source) {
element.autocomplete(
source,
{
dataType: "json",
formatItem: function(data, i, max, value, term) {
return value;
},
parse: function(data) {
var array;
var i;
array = [];
for (i = 0; i < data.length; i++) {
array[i] =
{
data: data[i],
value: data[i],
result: data[i]
};
}
return array;
}
}
);
};
*/

/*
//The navigation scroller need to be in two divs. The parent div should have position relative
//and the child div should hae position fixed. The containerPath holds the path of parent element in DOM
//and controlPAth holds the path of child element in DOM
Origin.CreateNavigationScroller = function(containerPath, controlPath) {
var startingTop;
var navigation = $(controlPath);
var container = $(containerPath);
$(function() {
startingTop = container.offset().top;
fixed();
$(window).scroll(function() {
fixed();
});
$(window).resize(function() {
fixed();
});
});

function fixed() {
var offsetTop = $(window).scrollTop();
var offsetLeft = $(window).scrollLeft();
if (offsetTop > startingTop) {
navigation.css('top', '0');
} else {
var px = startingTop - offsetTop;
px = px + 'px';
navigation.css('top', px);
}
navigation.css('left',  $(containerPath).offset().left - offsetLeft+'px');
}
};
*/

Origin.Controls = {};

// Used by an HTML Helper Extension
Origin.Controls.AddValidatedInputListeners = function (textBoxId, validationExpression, isRequired) {
	var textBox = $("#" + textBoxId);

	textBox.blur(function () {
		var exp = new RegExp(validationExpression, "i");

		if ($.trim(textBox.val()).length > 0 && !exp.test($.trim(textBox.val())))
			textBox.addClass("failedValidation");
		else {
			if (isRequired == "1" && $.trim(textBox.val()).length == 0)
				textBox.addClass("failedValidation");
			else
				textBox.removeClass("failedValidation");
		}
	});
}

// Used by an HTML Helper Extension
Origin.Controls.AddTextBoxGridListeners = function (gridId, validationExpression) {
	var grid = $("#" + gridId);

	grid.getValues = function () {
		var values =
		{
			gridValues: grid.find("input").joinValues(),
			pasteValues: grid.find("textarea").val()
		};

		return values;
	};

	grid.bind("clearAll", function () {
		grid.clearGrid();
		grid.clearCutPaste();
	});

	grid.clearGrid = function () {
		this.find("input")
			.removeAttr("value")
			.removeClass("failedValidation")
			.end()
				.trigger('textboxgridcleared');

		this.find(".row:gt(" + this.attr("minRows") + ")").remove();
	};

	grid.clearCutPaste = function () {
		grid.find("textarea").removeAttr("value").end().trigger('textboxgridcleared');
	};

	grid.find(".clearGridLink").click(function () {
		grid.clearGrid();
	});

	grid.find(".clearCopyPasteLink").click(function () {
		grid.clearCutPaste();
	});

	grid.find("input").blur(function () {
		var input = $(this);
		var exp = new RegExp(validationExpression);

		if ($.trim(input.val()).length > 0 && !exp.test($.trim(input.val())))
			input.addClass("failedValidation");
		else
			input.removeClass("failedValidation");

		// This is ugly... there must be a way to select all inputs that do NOT have a value...
		if ((grid.find("input").length - grid.find("input[value]").length) <= 1) {
			var newRow = grid.find("div.row:first").clone(true); // clone elements AND events...

			newRow.find("input")
				.removeAttr("value")
				.removeClass("failedValidation");

			newRow.appendTo(grid.find(".textBoxContainer"));
		}
	});

	grid.find(".toggleCopyPasteLink").click(function () {
		$(this)
			.toggleClass("expanded")
			.parent()
				.find(".copyPasteRegion")
				.toggle()
				.find('textarea').eq(0).focus();
	});
};

Origin.Controls.AddSingleCheckCheckboxListeners = function () {
	$("input.singleCheckCheckbox:checkbox").click(function () {
		var isChecked = $(this).attr("checked");
		$(this).parent().parent().find("input:checkbox").attr("checked", false);

		if (isChecked)
			$(this).attr("checked", true);
	});
};


Origin.redirect = function (url) {
	// Cancel ajax requests
	$.ajaxAbort();

	// This is needed to address an Internet Explorer "feature" of not setting
	// the HTTP_REFERER header when using window.location
	if ($.browser.msie) {
		// IE will not respect the click event in some instances 
		// and drop the redirect. This timer will then fallback 
		// to force the redirect (uses the onbeforeunload event 
		// to test if the redirect is already occurring
		var forceRedirect = setTimeout(function () {
			// If this code executes, the redirect was unsuccessful
			// Force it (without the HTTP_REFERER)
			window.location.href = url;
		}, 2000);

		// This is a proprietary IE event that is triggered before the user 
		// navigates away from the page. If it returns a value the user is 
		// prompted
		window.onbeforeunload = function () {
			// IE is successfully redirecting, so remove 
			// our force redirect timeout
			clearTimeout(forceRedirect);
		};

		// Remove any click handlers that would prevent us from redirecting
		$('body').add(document).unbind('click');
		$('<a href="' + url + '"></a>').appendTo('body')[0].click();
	} else {
		window.location.href = url;
	}
};

/*
* Generates a unique ID for the current document
*/
Origin._guid = 0;
Origin.guid = function () {
	return 'origin-guid-' + (Origin._guid++);
};

/*
* Opens a help sized modal window
*/
Origin.showHelp = function (options) {
	if (arguments.length == 1 && typeof arguments[0] == 'string') {
		options = {
			url: (arguments[0].indexOf('/') > -1 ? arguments[0] : '/Help/' + arguments[0])
		}
	} else if (arguments.length == 2 && typeof arguments[0] == 'string' && typeof arguments[1] == 'string') {
		var content = $('<div class="originModal"></div>')
			.html(arguments[1])
			.appendTo('body');
		options = {
			title: arguments[0],
			content: content
		}
	}
	options = $.extend(options, {
		width: 360,
		height: 215,
		open: function (dialog) {
			$('.ui-dialog-titlebar', dialog).addClass('ui-widget-header ui-corner-all');
		},
		dialog: {
			modal: false,
			draggable: true,
			dialogClass: 'modalHelp',
			resizable: true,
			position: ['right', 'top']
		},
		buttons: ['close']
	});
	if (options.size && options.size == 'large') {
		options.dialog.modal = true;
	}
	Origin.modal(options);
};

/*
* Shows/hides the content loading for the entire page
*/
Origin.showLoading = function () {
	$('body').showContentLoading('large');
};
Origin.hideLoading = function () {
	$('body').hideContentLoading();
};

/*
* Validate methods for various regular expressions and patterns
*/
Origin.validate = {
	equals: function (str1, str2) {
		return $.trim(str1) == $.trim(str2);
	},
	required: function (str) {
		return ($.trim(str) || "").length > 1;
	},
	email: function (email) {
		return /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,128}$/.test(email);
	},
	ipAddress: function (ip) {
		return /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ip);
	},
	phone: function (phone) {
	    //return /^([0-9.)(-]+)$/.test(phone);
	    return /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/.test(phone);
	}
};

/// Display a notice onscreen 
Origin.notify = function (options) {
	return $.originNotice(options);
};

Origin.notifySuccess = function (message) {
	return Origin.notify({ type: 'success', message: message });
};

Origin.notifyInfo = function (message) {
	return Origin.notify({ type: 'info', message: message });
};

Origin.notifyError = function (message) {
	return Origin.notify({ type: 'error', message: message });
};

// Throttles the number of requests that can come through at once, clears any existing 
// timeouts
var THROTTLED = {};
Origin.throttle = function (key, timeout, callback) {
	clearTimeout(THROTTLED[key]);
	var context = document;
	if (arguments.length == 4) {
		context = arguments[2];
		callback = arguments[3];
	}
	THROTTLED[key] = setTimeout(function () {
		callback.call(context);
	}, timeout);
};

Origin = $.extend(Origin, {
	getCookie: jQuery.cookie,
	setCookie: jQuery.cookie,
	deleteCookie: function (name) {
		return jQuery.cookie(name, null);
	},
	cookieExists: function (name) {
		if (document.cookie && document.cookie != '') {
			var cookies = document.cookie.split(';');
			for (var i = 0; i < cookies.length; i++) {
				var cookie = jQuery.trim(cookies[i]);
				// Does this cookie string begin with the name we want?
				if (cookie.substring(0, name.length + 1) == (name + '=')) {
					return true;
				}
			}
		}
		return false;
	},
	setCookieIfNotExists: function (name, value, options) {
		if (!Origin.cookieExists(name)) {
			if (arguments.length == 1) {
				value = (new Date()).toString();
			}
			Origin.setCookie(name, value, options);
			return true;
		}
		return false;
	}
});

Origin.addHistory = function (state, title) {
	window.location.hash = state;
	if (arguments.length == 2) {
		Origin.setTitle(title);
	}
};

Origin.replaceHistory = function (state, title) {
	window.location.replace('#' + state);
	if (arguments.length == 2) {
		Origin.setTitle(title);
	}
};

Origin.clearHistory = function () {
	window.location.hash = '';
};

Origin.onHistory = function (callback) {
	$(window).bind('historychanged', function (evt, data) {
		callback(data);
	});
};

Origin.setTitle = function (title) {
	var i = document.title.indexOf('-');
	var dt = document.title;
	if (i > -1) {
		dt = document.title.substr(i + 1);
	}
	document.title = title + ' - ' + dt;
};

var ElementsToCheck = [];
Origin.addCheckedAttributes = function () {
	for (var i = 0; i < ElementsToCheck.length; i++) {
		$(ElementsToCheck[i]).attr('checked', 'checked');
	}
	ElementsToCheck = [];
};


Origin.SalesforceKeepAlive = function () {
    $.get('/Static/SalesforceKeepAlive', function (returnData) {
        //alert("Keep Alive Called " + returnData);
    });
};

var crmKeepAlive;

Origin.activateKeepAlive = function (crm) {
    crmKeepAlive = window.setInterval(function () {
        if ($('#frmClaimRenew' + crm).length > 0)
            $('#frmClaimRenew' + crm).remove();
        var $iframe = $('<iframe id="frmClaimRenew' + crm + '" src="/' + crm + '/KeepAlive" style="display:none;"></iframe>');
        $('body').append($iframe);
    }, 120000);
};

Origin.clearKeepAlive = function () {
    window.clearInterval(crmKeepAlive);
};

Origin.getQueryStringParameter = function (name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return '';
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};
Origin.addQueryStringValueToPath = function(path, key, value) {
    return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
};

/*
*	This class allows to execute functionality upon timeout. Once a request is made through 
start method to execute a function after a timeOut, any further requests will reset the timeout 
and start method will wait till timeOut expires.
TODO: Need to add an initializer.
*/
var originTimer = {
	started: false,
	timeOut: 500,
	timeoutId: null,
	start: function (func, _timeOut) {
		var _timer = this;
		_timer.clear();
		_timer.started = true;

		_timer.timeoutId = setTimeout(function () {
			if (_timer.started) {
				func.call();
			}

			_timer.started = false;
		}, (arguments.length > 1) ? _timeOut : _timer.timeOut);
	},
	clear: function () {
		this.started = false;
		if (this.timeoutId) {
			clearTimeout(this.timeoutId);
			this.timeoutId = null;
		}
	}
};

/*********
Set a 15 minute timer to determine if user is still authenticated
If no longer authenticated, redirect to login page
*********/
// set a timeout that expires 900000 Milliseconds (15 Minutes) from now
function OriginAuthStartTimer() {
    setTimeout(function () { OriginCheckAuthenticated(); }, 900000);
}

function OriginCheckAuthenticated() {
    $.ajax({
        type: 'get',
        url: '/Static/IsUserAuthenticated',
        dataType: 'json'
    })
	.done(function (response) {
	    console.log("success", response);
	    if (response.IsAuthenticated)
	        OriginAuthStartTimer();
	    else {
	        window.location = response.Url;
	    }
	})
    .fail(function () {
        console.log("failed", response);
        OriginAuthStartTimer();
    });
}

//$(document).ready(function () {
//    OriginAuthStartTimer();
//});



